import React from "react";
import { useState } from "react";
import Footer from "../../components/footer";
import Gotop from "../../components/gotop";
import LoginHeader from "../../components/header/LoginHeader";
import MobileHeader from "../../components/header/MobileHeader";
import ManageCard from "./ManageCard";
import InstituteHeader from "../../components/header/InstituteHeader";
import InstituteMobileHeader from "../../components/header/InstituteMobileHeader";
import { Helmet } from "react-helmet";

ManageBatch.propTypes = {};

function ManageBatch(props) {
  const [toggle, setToggle] = useState({
    key: "",
    status: false,
  });
  const [isShowMobile, setShowMobile] = useState(false);

  const handleToggle = (key) => {
    if (toggle.key === key) {
      setToggle({
        status: false,
      });
    } else {
      setToggle({
        status: true,
        key,
      });
    }
  };

  const handleMobile = () => {
    const getMobile = document.querySelector(".menu-mobile-popup");
    setShowMobile(!isShowMobile);
    !isShowMobile
      ? getMobile.classList.add("modal-menu--open")
      : getMobile.classList.remove("modal-menu--open");
  };
  return (
    <>
     <Helmet>
				<title>Manage-class | Jobkikhoj</title>
				<meta name="description" content=" " />
				<meta name="keywords" content=" " />
				<meta property="og:title" content="Manage-class | Jobkikhoj " />
				<meta property="og:description" content="" />
				<meta property="og:url" content="https://jobkikhoj.com" />
			</Helmet>
      <InstituteMobileHeader handleMobile={handleMobile} />
      <InstituteHeader clname="manageBatch" handleMobile={handleMobile} />

      {/* <Breadcrumb title="Applied Jobs" className="breadcrumb-section" /> */}
      <div className="pt-70">
        <ManageCard />
        {/* <Footer /> */}
        <Gotop />
      </div>
    </>
  );
}

export default ManageBatch;
